import React from 'react';
import { Card } from 'react-native-paper';
import { styles } from './ProfileViewStyle';
import { useNarrowCardStyle } from './ResponsiveFormContext';
/**
 * The intake-form card. Same as `<Card style={styles.card}>`, except on
 * narrow public sign-up, where it fits the window.
 */
export const FormCard = ({ children }) => {
    const narrowStyle = useNarrowCardStyle();
    return <Card style={[styles.card, narrowStyle]}>{children}</Card>;
};
